import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert } from "@material-ui/lab";
import {
  Snackbar,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@material-ui/core";
import AuthContext from "../../store/auth-context";

function ScheduleBooking(props: any) {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalText, setModalText] = useState<string>("");
  const [modalType, setModalType] = useState<string>("");
  const [selectedPatient, setSelectedPatient] = useState<any>(0);
  const [familyMemberList, setFamilyMemberList] = useState<any>([]);

  const authCtx = useContext(AuthContext);
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const brandName = localStorage.getItem("brandName");

  useEffect(() => {
    props.setPatientName(user.firstName + " " + user.lastName);
    const getFamilyList = async () => {
      fetchFamilyList();
    };
    getFamilyList();
  }, []);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const fetchFamilyList = async () => {
    authCtx.toggleLoader(true);
    const familyMembers = JSON.parse(
      localStorage.getItem("familyMemberList") || "[]"
    );
    if (familyMembers) {
      setFamilyMemberList(familyMembers);
      props.setFamilyMemberList(familyMembers);
    } else {
      setFamilyMemberList([]);
      props.setFamilyMemberList([]);
      handleShow();
      setModalText(t("No family members found"));
      setModalType("error");
      setTimeout(() => {
        setModalText("");
        handleClose();
      }, 3000);
    }
    authCtx.toggleLoader(false);
  };

  const handleSelectedPatient = (familyMemberId: any) => {
    setSelectedPatient(familyMemberId);
    props.setFamilyMemberId(familyMemberId);
    if (familyMemberId === 0) {
      props.setPatientName(user.firstName + " " + user.lastName);
    } else {
      let familMember = familyMemberList.find(
        (item: any) => item.familyMemberId === familyMemberId
      );
      let patientName = familMember.firstName + " " + familMember.lastName;
      props.setPatientName(patientName);
    }
  };

  const handlePaymentMode = (e: any) => {
    props.setSelectedPaymentMode(e.target.value);
  };
  return (
    <>
      <div className="mt-3" key={"select-patient-start"}>
        <p className="fs-18 fw-600" key="select-patient-1">
          {t("Select Patient")}
        </p>
        <div className="row" key="user-row-1">
          <div className="col-xl-2 col-sm-4 py-2 py-xl-0 ">
            <input
              key="user-0"
              type="radio"
              className="btn-check no-focus"
              name="Morning"
              id="user-0"
              value={selectedPatient}
              checked={selectedPatient === 0}
              onChange={(e) => handleSelectedPatient(0)}
            />

            <label
              key="schedule-booking-1"
              className="d-inline-flex justify-content-center align-items-center schedule-booking-input input-outline-primary text-center no-focus cursor-pointer py-1 px-1"
              htmlFor="user-0"
              dir="ltr"
            >
              <img
                src={
                  user.gender === "M"
                    ? "../assets/images/male.png"
                    : "../assets/images/female.png"
                }
                alt="user-image"
                className="img-36"
              />
              <div className="mx-1">
                <p className="fs-14 my-0 text-start text-truncate name-wrap">
                  {user.firstName + " " + user.lastName}
                </p>
                <p className="fs-12 my-0 text-start">{t("MySelf")}</p>
              </div>
            </label>
          </div>
          {familyMemberList &&
            familyMemberList.length > 0 &&
            familyMemberList.map((item: any) => (
              <div className="col-xl-2 col-sm-4 py-2 py-xl-0 ">
                <input
                  key={"fam-" + item.familyMemberId}
                  type="radio"
                  className="btn-check no-focus"
                  name="Morning"
                  id={"fam-" + item.familyMemberId}
                  value={selectedPatient}
                  checked={selectedPatient === item.familyMemberId}
                  onChange={(e) => handleSelectedPatient(item.familyMemberId)}
                />

                <label
                  key={"family-" + item.familyMemberId}
                  className="d-inline-flex justify-content-center align-items-center schedule-booking-input input-outline-primary text-center no-focus cursor-pointer py-1 px-1"
                  htmlFor={"fam-" + item.familyMemberId}
                  dir="ltr"
                >
                  <img
                    src={
                      item.genderId === 1
                        ? "../assets/images/male.png"
                        : "../assets/images/female.png"
                    }
                    alt="user-image"
                    className="img-36"
                  />
                  <div className="mx-1">
                    <p className="fs-14 my-0 text-start text-truncate name-wrap">
                      {item.firstName + " " + item.lastName}
                    </p>
                    <p className="fs-12 my-0 text-start">{item.relation}</p>
                  </div>
                </label>
              </div>
            ))}
        </div>
      </div>
      <div className="mt-5" key="mode-of-payment">
        <p className="fs-18 fw-600 mb-1" key="select-patient-1">
          {t("Mode Of Payment")}
        </p>
        <div className="d-flex">
          <FormControl>
            <RadioGroup
              row
              value={props.selectedPaymentMode}
              onChange={handlePaymentMode}
            >
              <FormControlLabel
                value="1"
                control={<Radio className="ps-0" />}
                className="mx-0"
                label={<span className="fs-14">{t("Pay By Insurance")}</span>}
              />
              <FormControlLabel
                value="2"
                control={<Radio />}
                className="mx-4"
                label={<span className="fs-14">{t("Pay By Myself")}</span>}
              />
            </RadioGroup>
          </FormControl>
        </div>
        <ul className="text-muted mt-4 px-3">
          <li>
            {brandName === "llh"
              ? t(
                  "LLH team will connect you for further details & Consultation fees."
                )
              : t(
                  "Burjeel team will connect you for further details & Consultation fees."
                )}
          </li>
          <li>
            {t(
              "Consultation fees will be subjected to your insurance provider."
            )}
          </li>
        </ul>
        <button
          className="btn btn-primary px-5 no-focus btn-primary-linear"
          onClick={() =>
            props.setSelectedProcess("patient-selection-completed")
          }
        >
          {t("Proceed")}
        </button>
      </div>

      {modalType === "error" && (
        <Snackbar
          open={showModal}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="error">
            {modalText}
          </Alert>
        </Snackbar>
      )}
      {modalType === "success" && (
        <Snackbar
          open={showModal}
          onClose={() => {
            handleClose();
            setModalText("");
          }}
        >
          <Alert onClose={handleClose} severity="success">
            {modalText}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}

export default ScheduleBooking;
